/* unplugin-vue-components disabled */import { render } from "./GroundPerspectiveRender.vue?vue&type=template&id=56a08320&scoped=true"
import script from "./GroundPerspectiveRender.vue?vue&type=script&lang=js"
export * from "./GroundPerspectiveRender.vue?vue&type=script&lang=js"

import "./GroundPerspectiveRender.vue?vue&type=style&index=0&id=56a08320&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a08320"]])

export default __exports__